import { render, staticRenderFns } from "./downApp.vue?vue&type=template&id=af17f314&scoped=true&"
import script from "./downApp.vue?vue&type=script&lang=js&"
export * from "./downApp.vue?vue&type=script&lang=js&"
import style0 from "./downApp.vue?vue&type=style&index=0&id=af17f314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af17f314",
  null
  
)

export default component.exports